// Czas z API to czas polski (Europe/Warsaw), także z sufiksem „Z”. Te funkcje nie zależą od strefy
// przeglądarki (wzorzec: sledz-app/src/utils/dateTime.js). Używane przez widoki punktu kontrolnego.

const TIME_ZONE = 'Europe/Warsaw'

const partsFormat = new Intl.DateTimeFormat('en-US', {
  timeZone: TIME_ZONE,
  hourCycle: 'h23',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
})

const clockFormat = new Intl.DateTimeFormat('pl-PL', {
  timeZone: TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
})

// Przesunięcie Warszawy względem UTC (ms) w danej chwili.
function warsawOffsetMs (utcMs) {
  const p = {}
  for (const part of partsFormat.formatToParts(new Date(utcMs))) p[part.type] = part.value
  const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second)
  return asUtc - Math.floor(utcMs / 1000) * 1000
}

const WALL_CLOCK = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3})\d*)?)?/

// "2026-10-18 10:15:30" (albo z T / „Z” / ułamkiem sekundy) jako czas polski → ms epoki; null gdy nie da się odczytać.
export function parseApiTime (value) {
  if (value == null || value === '') return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  const m = WALL_CLOCK.exec(String(value).trim())
  if (!m) return null
  const guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0), +((m[7] || '0').padEnd(3, '0')))
  let ms = guess - warsawOffsetMs(guess)
  ms = guess - warsawOffsetMs(ms) // druga iteracja na zmianę czasu
  return ms
}

// Czas odbicia z czytnika (websocket `new_punch`): ze strefą (Z / +02:00) = prawdziwa chwila,
// bez strefy = czas polski (jak `_parse_dt_pl` w new_herring). Liczba = unix w s albo ms.
export function parsePunchTime (value) {
  if (value == null || value === '') return null
  if (typeof value === 'number') return value < 1e12 ? value * 1000 : value
  const text = String(value).trim()
  if (/(Z|[+-]\d{2}:?\d{2})$/.test(text)) {
    const ms = Date.parse(text.replace(' ', 'T'))
    return Number.isNaN(ms) ? null : ms
  }
  return parseApiTime(text)
}

export function formatClock (ms) {
  return ms == null ? '--:--:--' : clockFormat.format(new Date(ms))
}

// 3723000 → "1:02:03"
export function formatDuration (ms) {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return '--:--:--'
  const total = Math.round(ms / 1000)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

// Strata do pierwszego: "+0:42", "+1:02:03".
export function formatGap (ms) {
  if (ms == null || !Number.isFinite(ms) || ms <= 0) return ''
  const total = Math.round(ms / 1000)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  return h > 0
    ? `+${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `+${m}:${String(s).padStart(2, '0')}`
}
